import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownListComponent, MultiselectComponent, MultiselectItem } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { TranslateService } from 'src/app/services/translate/translate.service';

@Component({
  selector: 'aos-operator-text-dynamic-filter',
  imports: [ReactiveFormsModule, DropdownListComponent, MultiselectComponent, TranslateModule],
  template: `
    @if (form()) {
      <form
        class="aos-dynamic-filters"
        [formGroup]="form()"
      >
        @let operatorCtrl = form().get('operator');
        @let valuesCtrl = form().get('values');
        @if (operatorCtrl) {
          <ui-dropdown-list
            class="aos-dynamic-filters__filter-dropdown"
            [formControl]="$any(operatorCtrl)"
            [items]="operatorItemsTranslated()"
            [default]="defaultOperatorItemsTranslated()"
            [selected]="selectedOperatorItemTranslated()"
          ></ui-dropdown-list>
        }
        @if (valuesCtrl) {
          <ui-multiselect
            [style.width]="'100%'"
            [formControl]="$any(valuesCtrl)"
            [items]="valueItems()?.length ? valueItems()! : []"
            [selected]="selectedValueItems()?.length ? selectedValueItems()! : []"
            [labelSelectAll]="labelSelectAll | translate"
            [labelUnselectAll]="labelUnselectAll | translate"
            [labelAllSelected]="labelAllSelected | translate"
            [labelSelected]="labelSelected | translate"
            [placeholder]="placeholder | translate"
          ></ui-multiselect>
        }
      </form>
    }
  `,
  styleUrl: './dynamic-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiselectDynamicFilterComponent {
  form = input.required<FormGroup>();
  operatorItems = input.required<MultiselectItem[]>();
  defaultOperatorItems = input.required<MultiselectItem>();
  selectedOperatorItem = input.required<MultiselectItem>();
  valueItems: InputSignal<MultiselectItem[] | undefined> = input.required();
  selectedValueItems = input.required<MultiselectItem[] | undefined>();

  private readonly translate = inject(TranslateService);

  protected operatorItemsTranslated = computed(() => this.translate.getTranslatedItems(this.operatorItems()));
  protected defaultOperatorItemsTranslated = computed(
    () => this.translate.getTranslatedItems([this.defaultOperatorItems()])[0]
  );
  protected selectedOperatorItemTranslated = computed(
    () => this.translate.getTranslatedItems([this.selectedOperatorItem()])[0]
  );

  protected readonly labelSelectAll = TranslateRegistry.get.FILTER.COMMON.SELECT_ALL;
  protected readonly labelUnselectAll = TranslateRegistry.get.FILTER.COMMON.UNSELECT_ALL;
  protected readonly labelAllSelected = TranslateRegistry.get.FILTER.COMMON.ALL_SELECTED;
  protected readonly placeholder = TranslateRegistry.get.FILTER.COMMON.SELECT_MODEL_TYPE;
  protected readonly labelSelected = TranslateRegistry.get.FILTER.COMMON.SELECTED;
}
